<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div :class="resignType == '4' ? 'modal-dialog resign-modal-dialog' : 'modal-dialog'">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">撥出對象-{{segmentName}}</h3>
        </div>
        <div class="modal-body">
            <section class="search pb-0 mb-4">
                <div class="row">
                    <div class="col-12">
                        <form class="form">
                            <div class="input-group input-lg">
                            <div class="input">
                                <input
                                type="text"
                                name="keyowrd"
                                id="keyowrd"
                                class="form-control"
                                v-model="keyowrd"
                                placeholder="輸入服務人員姓名或收費代號進行搜尋...">
                            </div>
                            <button
                            class="btn btn-primary btn-icon"
                            type="submit"
                            @click.prevent="doSearch()">
                                <i class="icon-search i-24"></i>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <div v-if="segmentName=='全單位未訪件'">
                <h4>【年份】:
                  <select v-model="years" @change="doSearch"  class="form-control form-control-inline form-wide">
                 <!-- <select> -->
                    <option value="">全部</option>
                    <option
                    v-for="(item, i) in yearsOpt"
                    :key="`item-${i}`"
                    :value="item">
                    <!--<text v-if ="item=='109'">{{item}}(1-4月建議調撥)</text>
                    <text v-else>{{item}}</text>-->
                    <text >{{item}}</text>
                    </option>
                  </select> 年</h4>    
            </div>    
            <table class="segment-table table datatable table-striped table-bordered">
                <thead>
                    <tr>               
                        <th width="60px">
                        <div v-if="resignType != '4'" class="checkbox checkbox-inline mr-0">
                            <input 
                            @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                            type="checkbox" 
                            name="check-all" 
                            id="check-all" 
                            value="1" 
                            v-model="checkAll"
                            :disabled="segmentName == '離職、退休人員'">
                            <label for="check-all"></label>
                        </div>
                        </th>
                        <th width="90px" v-if="segmentName == '離職、退休人員'">現行收費<br>人員姓名</th>
                        <th width="100px" v-if="segmentName != '離職、退休人員'">姓名</th>
                        <th width="100px">收費代號</th>
                        <th width="130px" v-if="segmentName!='公件'">服務件數<br>(自招/非自招)</th>
                        <th width="100px" v-if="segmentName=='離職、退休人員'">應撥人數</th>                        
                        <th width="170px" v-if="segmentName=='全單位未訪件'">年份</th>
                        <th v-if="segmentName != '離職、退休人員'">要保人數</th>
                        <template v-if="segmentName == '離職、退休人員'">
                            <th width="100px">要保人數</th>
                            <th v-if="resignType == '1'">離退職<br>人員名單</th>
                            <th width="80px" v-if="resignType == '4'">增員者</th>
                            <th v-if="resignType == '4'">備註</th>
                        </template>
                    </tr>
                </thead>
                <tbody v-if="true">
                    <tr v-for="(d, did) in agntList" :key="`td-${did}`">
                        <td width="60px">
                        <div v-if="resignType != '4' || segmentName != '離職、退休人員'" class="mr-0 checkbox checkbox-inline">
                            <input
                            @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                            type="checkbox"
                            name="`td-item[]`"
                            :id="`check-${did}`"
                            :value="d"
                            v-model="selection"
                            :disabled="d === '' || segmentName == '離職、退休人員'"
                            @change="$emit('update', selection)">
                            <label :for="`check-${did}`"></label>
                        </div>
                        <div v-if="resignType == '4' && segmentName == '離職、退休人員'" class="mr-0 radio radio-inline">
                            <input
                                v-model="resignInfo"
                                type="radio"
                                :id="`check-${did}`"
                                :value="d"
                                @change="$emit('update', resignInfo)"
                            >
                            <label :for="`check-${did}`"></label>
                        </div>
                            <!-- <div class="checkbox checkbox-inline mr-0">
                                <input type="checkbox" name="td-item" :id="`check-${d.agidno}`" 
                                :value="d"
                                v-model="selection">
                                <label :for="`check-${d.agidno}`"></label>
                            </div> -->
                        </td>
                        <td :width="segmentName == '離職、退休人員' ? '90px' : '100px'">{{ d.ceempnm }}</td>
                        <td width="100px">{{d.clcno}}</td>
                        <td width="130px" v-if="segmentName!='公件'">{{d.tmp1}} / {{d.tmp2}}</td>                         
                        <td width="100px" v-if="segmentName=='離職、退休人員'">{{d.tmp7}}</td>                         
                        <!-- <td width="170px" v-if="segmentName=='全單位未訪件' && d.code_nm.includes('109')">{{d.code_nm | yearsSliceFormat}}(1-4月建議調撥)</td>
                        <td width="170px" v-else-if="segmentName=='全單位未訪件'">{{d.code_nm | yearsSliceFormat}}</td>-->
                        <td width="170px" v-if="segmentName=='全單位未訪件'">{{d.code_nm | yearsSliceFormat}}</td>
                        <td v-if="segmentName != '離職、退休人員'">{{d.cs_count}}</td>
                        <template v-if="segmentName == '離職、退休人員'">
                            <td width="100px">{{d.cs_count}}</td>
                            <td v-if="resignType == '1'">
                                <a @click="queryResignList(d)" class="link text-underline">名單</a>
                            </td>
                            <td width="80px" v-if="resignType == '4'">{{ d.intr_name }}</td>
                            <td v-if="resignType == '4'">{{ d.intr_name ? "2023/13工後入職" : "" }}</td>
                        </template>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                    <td colspan="7" class="empty">
                        <h3 class="text-center py-5">無客戶資料</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    </tr>
                </tbody>
            </table>

            <div class="row">
                <div class="col-12 text-right">
                    <button type="button" @click="$emit('close')" class="btn btn-default">取消</button>
                    <button v-if="resignType != '4' || segmentName != '離職、退休人員'" type="button" @click="$emit('submit', selection)" class="btn btn-primary" :disabled="segmentName == '離職、退休人員'">加入</button>
                    <button v-if="resignType == '4' && segmentName == '離職、退休人員'" type="button" @click="doOpenConfirmModal" class="btn btn-primary">加入</button>
                </div>
            </div>
        </div>
      </div>
    </div>

    <resign-modal
        :open="resignModalOpen"
        :cedvno3="cedvno3"
        @close="panelClose('resignModalOpen')"
        @close-all="doCloseAllModal"
    />

    <unlock-resign-modal
        :confirmModalOpen="confirmModalOpen"
        :resignInfo="resignInfo"
        page="manger"
        @close="doCloseUnlockModal"
        @close-all="doCloseUnlockModal"
    />

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { commonMixin } from "@/mixins/common";
import { doQueryResignUnlock } from "@/service";
import ResignModal from "@/desktop/components/manager/ResignModal";
import UnlockResignModal from "@/desktop/components/manager/UnlockResignModal";

export default {
    name: 'DialOutPersonModal',
    mixins: [commonMixin],
    components: { ResignModal, UnlockResignModal },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        segmentAgntList: {
            type: Array,
            default: () => {
                return []
            },
        },
        segmentName:{
            type: String,
            default: () => {
                ''
            },
        },
        // 1: 專招, 4: 展業
        resignType: {
            type: String,
            default: ""
        }
    },
    watch: {
        open: function () {
            this.updateList()
        },
        segmentAgntList () {  // 產生全單位未訪件年份下拉選單
            let result = []
            this.segmentAgntList.forEach(item => {
               if(!result.includes(item.code_nm.slice(0,3))) {result.push(item.code_nm.slice(0,3))}
            })
            this.yearsOpt = result.sort().reverse()
        },
        years: function(){
            this.doSearch();
        }, 
        clickTarget: function(target){
            if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
            if(this.checkAll) {  //點了全選
                this.selection = []
                this.agntList.forEach(data => {
                this.selection.push(data)
                });
            } else {  //取消全選
                this.selection = []
            }
            } else {  //點了其他checkbox
            this.checkAll = this.selection.length == this.agntList.length
            }
            this.$emit('update', this.selection)
        },           
    },
    data () {
        return {
            checkAll:false,
            clickTarget:'',
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            years:'',
            selection: [],
            agntList: [],
            yearsOpt: [],
            resignModalOpen: false,
            cedvno3: "",
            confirmModalOpen: false,
            resignInfo: {}
        }
    },
    methods: {
        doSearch () {
            this.checkAll = false
            this.clickTarget = "clickAll-again"
            this.selection = []
            // 難字 update
            this.agntList = []
            setTimeout(() => {
                this.agntList = this.segmentAgntList.filter(item => {
                    return item.ceempnm.includes(this.keyowrd) && item.code_nm.includes(this.years) || item.clcno.includes(this.keyowrd) && item.code_nm.includes(this.years)
                })
                this.registerHanlink()  
            }, 100);
        },
        updateList () {
            this.checkAll = false
            this.selection = []
            this.years = ''
            this.keyowrd = ''
            //  for 難字 更新 array
            this.agntList = []
            const vm = this
            setTimeout(() => {
                vm.agntList = [...vm.segmentAgntList]
                this.registerHanlink()  // 難字 update
            }, 100);
        },
        /**
         * 查詢離退人員清單
         * @param {Object} empData 
         */
        queryResignList(empData) {
            this.selection = [];
            this.selection.push(empData);
            this.cedvno3 = empData.clcno.substring(0, 3);
            this.panelOpen("resignModalOpen");
        },
        /** 關閉已開啟的modal  */
        doCloseAllModal: function() {
            this.panelClose("resignModalOpen");
            if (this.resignType === "4" || this.resignType === "1") {
                const resignInfo = this.$store.state.resignInfo
                this.selection.forEach(item => item.is_unlock = resignInfo.is_unlock)
            }
            this.$emit("close-resign", this.selection);
        },
        /** 開啟確認視窗 */
        doOpenConfirmModal: function() {
            if (!this.resignInfo.agidno) {
                this.$toast.info({ title: "請選擇離職、退休人員" });
                return;
            }

            if (!this.resignInfo.resign_id && !this.resignInfo.intr_id) {
                this.resignInfo.is_unlock = '';
                this.selection = [];
                this.selection.push(this.resignInfo);
                this.$emit("close-resign", this.selection);
                return;
            }

            doQueryResignUnlock(
                this.$store.state.userInfo.id,
                this.resignInfo.resign_id,
                this.resignInfo.intr_id
            ).then((result) => {
                if (result && result.header.status == "200" && result.body) {
                    if (result.body.is_unlock === "N") {
                        this.panelOpen("confirmModalOpen");
                    } else {
                        this.selection = [];
                        this.resignInfo.is_unlock = 'Y'
                        this.selection.push(this.resignInfo);
                        this.$emit("close-resign", this.selection);
                    }
                }
            });
        },
        /** 關閉確認視窗 */
        doCloseUnlockModal: function() {
            this.panelClose("confirmModalOpen");
            if (this.resignType === "4" || this.resignType === "1") {
                this.selection = [];
                this.selection.push(this.resignInfo);
            }
            this.$emit('close-resign', this.selection);
        }
    }
};
</script>

<style lang="scss" scoped>

.segment-table thead tr,.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.resign-modal-dialog {
    width: 1000px !important;
}
</style>